import {
  CREATE_BRAND, CHANGE_BRAND_ORDER, FETCH_ALL_BRANDS, CREATE_BRAND_EQUIPMENT,
  FETCH_BRAND, FETCH_BRAND_EQUIPMENT, UPDATE_BRAND, UPDATE_BRAND_EQUIPMENT,
  FETCH_REFERENCE_DETAIL, DELETE_BRAND, FETCH_ALL_TRAINER_BRANDS, FETCH_ALL_NCEP_TRAINER_BRANDS
} from '../actionTypes';

const initialState = {
  detail: {},
  equipment: {},
  brandlisting: [],
  referenceDetail: {},
  trainerNCEPListing: [],
  trainerListing: [],
  isLoadTrainerMore: false
};

export default function (state = initialState, action=null) {
  switch (action.type) {
    case CHANGE_BRAND_ORDER:
    case CREATE_BRAND:
    case FETCH_BRAND:
      return {
        ...state,
        detail: action.payload
      }
    case FETCH_REFERENCE_DETAIL:
      return {
        ...state,
        referenceDetail: action.payload
      }
    case UPDATE_BRAND:
      return { ...state, detail: { ...action.payload } };
    case DELETE_BRAND:
      return { ...state, detail: {} };
    case FETCH_ALL_BRANDS:
      return {
        ...state,
        brandListing: action.payload.brands
      }
    case FETCH_ALL_NCEP_TRAINER_BRANDS:
        return {
          ...state,
          trainerNCEPListing: action.payload.brands,
        }
    case FETCH_ALL_TRAINER_BRANDS:
        return {
          ...state,
          trainerListing: action.payload.brands,
        }
    case CREATE_BRAND_EQUIPMENT:
    case UPDATE_BRAND_EQUIPMENT:
    case FETCH_BRAND_EQUIPMENT:
      return { ...state, equipment: { ...action.payload } }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/brand.js